// extracted by mini-css-extract-plugin
export default {"wrapper":"kN7lUKh14pY0OKNzyqk4"};